import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../store';
import * as styles from '../styles/vcrm.module.scss';
import { VcrmIcon } from './icons';

interface Props {
  className?: string;
}

const VcrmIndicator: React.FC<Props> = ({ className }) => {
  const vcrmConnected = useSelector(
    (state: StoreState) => state.vcrm.isRegistered,
  );
  const vcrmConnecting = useSelector(
    (state: StoreState) => state.vcrm.isRegistering,
  );

  const indicatorProps = { class: '', message: '' };
  if (vcrmConnected) {
    indicatorProps.class = styles.registered;
    indicatorProps.message = 'Connected';
  } else if (vcrmConnecting) {
    indicatorProps.class = styles.registering;
    indicatorProps.message = 'Connecting...';
  } else {
    indicatorProps.class = styles.disconnected;
    indicatorProps.message = 'Disconnected';
  }
  return (
    <div
      title={indicatorProps.message}
      className={[
        styles.vcrmIconContainer,
        className,
        vcrmConnecting && !vcrmConnected ? styles.registeringIcon : '',
      ]
        .filter((x) => x)
        .join(' ')}
    >
      <VcrmIcon />
      <div className={[styles.vcrmIndicator, indicatorProps.class].join(' ')} />
    </div>
  );
};

export default React.memo(VcrmIndicator);
